export default __webpack_public_path__ + "static/media/checked-in-bg.f5c7520a.png";